<template>
	<div>
		<div class="sf-widget-top10">
			<ul>
				<li v-for="item in rank" :key="item.seq + item.scrName" @click="() => onClick(item)">
					<div class="rank">{{ item.seq }}</div>
					<section>
						<div class="d-flex justify-content-between">
							<div class="main-txt ellipsis">{{ getMessage_(item.msgKey1) }}</div>
							<div class="date">최근 접속: {{ item.lastConnection }}</div>
						</div>
						<div class="sub-txt ellipsis">
							{{ item.locations }}
						</div>
					</section>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
import client from '@/api/client';
import { rootComputed } from '@/store/common/helpers';
import { BASE_URL } from '@/constants';

const api = {
	selectScrTop10: () => client.get(`${BASE_URL}/widgetComponent/v1/scrTop10`).then(r => r.data)
};

export default {
	name: 'widget-lanking',
	async created() {
		this.refresh();
	},
	computed: {
		...rootComputed
	},
	methods: {
		onClick(item) {
			const message = {
				message: 'moveScreen',
				scrType: item.scrType,
				scrId: item.scrId,
				queryString: {}
			};
			// console.log('postMessage', message);
			window.parent.postMessage(message, '*');
		},
		async refresh() {
			const res = await api.selectScrTop10();
			if (res.body && res.body.length > 0) {
				this.rank = res.body
					.sort(r => r.seq)
					.slice(0, 10)
					.map(item => {
						const locations = Array.from({ length: 4 })
							.map((v, i) => 'msgKey' + (i + 1))
							.reverse()
							.map(key => {
								const msgKey = _.get(item, key);
								return msgKey && this.getMessage_(msgKey);
							});
						const lastConnection = this.$moment(lastConnection).format('YYYY-MM-DD');
						return { ...item, lastConnection, locations: _.compact(locations).join(' / ') };
					});
			}

			// console.log('ScrTop10', this.rank);
			return this.rank;
		}
	},
	data() {
		return {
			rank: [
				{
					cnt: 3,
					lastConnection: '2021-09-27',
					locations: 'Order / BSM Server',
					msgKey1: 'MWPO000051',
					msgKey2: 'SWCC000019',
					msgKey3: null,
					msgKey4: null,
					parentScrId: 'S00000002',
					rnum: 0,
					scrDesc: 'BSM Server',
					scrId: 'S10000100',
					scrName: 'BSM Server',
					scrUrl: '/mesvpo-fe-l/BSMServer',
					seq: 1,
					totalSize: 0
				},
				{
					cnt: 2,
					lastConnection: '2021-09-27',
					locations: 'Order / BSM Client',
					msgKey1: 'MWPO000052',
					msgKey2: 'SWCC000019',
					msgKey3: null,
					msgKey4: null,
					parentScrId: 'S00000002',
					rnum: 0,
					scrDesc: 'BSM Client',
					scrId: 'S10000101',
					scrName: 'BSM Client',
					scrUrl: '/mesvpo-fe-l/BSMClient',
					seq: 2,
					totalSize: 0
				},
				{
					cnt: 1,
					lastConnection: '2021-09-27',
					locations: 'Order',
					msgKey1: 'SWCC000019',
					msgKey2: null,
					msgKey3: null,
					msgKey4: null,
					parentScrId: null,
					rnum: 0,
					scrDesc: 'Order',
					scrId: 'S00000002',
					scrName: 'Order',
					scrUrl: null,
					seq: 3,
					totalSize: 0
				}
			]
		};
	}
};
</script>

<style></style>
